export default "/assets/b5bc26612cdf4d47affd6988bcdc8c0f.woff2";